import 'component/css/payment.css';

import { useState } from 'react';
import DatePicker from 'react-datepicker';

import API from 'service/api';
import Util, { Data } from 'service/util';

import Form from 'component/Form';
import PopMessage from 'component/pop-msg/PopMessage';
import Protected from 'component/Protected';


const PaymentAcceptModal = ({
  owner, bills, onUpdated, onClose
}) => {
  if (!owner) throw 'must provide owner info'
  if (!onUpdated) throw 'must provide payment update callback'

  const initCompanyList = () =>
  {
    var ls_comp = Array.from(
      owner.vehicles.reduce((r, v) => {
        v.services.forEach(s => r.add(s.company))
        return r
      }, new Set())
    )

    return ls_comp.length
      ? ls_comp
      : Data.company.map(c => c.cd)
  }

  const serviceCompanys = initCompanyList()
  
  const [error,     setError    ] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const [company,        setCompany      ] = useState(serviceCompanys[0])
  const [uid,            setUid          ] = useState(owner.id)
  const [cd_license,     setLicense      ] = useState('')
  const [transfer_dtm,   setTransferDate ] = useState(Util.getToday())
  const [payment_type,   setPaymentType  ] = useState('T')
  const [amount,         setAmount       ] = useState(0)
  const [ref_code,       setRefCode      ] = useState('')
  const [pay_month,      setPayMonth     ] = useState('')
  const [is_skipreceipt, setIsSkipReceipt] = useState(false)
  const [remarks,        setRemarks      ] = useState('')
  const [img,            setImage        ] = useState('')
  const [meta,           setMeta         ] = useState({
    stage: 1,
    img_width: 0,
    img_height: 0,
  })

  const onSetFile = (e) =>
  {
    let file = e.target.files[0]
    if (!file) {
      setImage(null)
      return
    }
    let fr = new FileReader()
    let img = new Image()
    fr.onload = () => img.src = fr.result
    img.onload = () => {
      let cvs = document.createElement('canvas')
      let ctx = cvs.getContext('2d')
      let nW = img.naturalWidth
      let nH = img.naturalHeight
      if (nW > 800 || nH > 800)
      {
        if (nW > nH)
          [nW, nH] = [800, 800/nW*nH]
        else
          [nH, nW] = [800, 800/nH*nW]

        cvs.width = nW
        cvs.height = nH

        ctx.drawImage(img,
          0,0,img.naturalWidth,img.naturalHeight,
          0,0,nW,nH
        )
      } else {
        cvs.width = nW
        cvs.height = nH
        ctx.drawImage(img,0,0)
      }
      meta.img_width  = nW
      meta.img_height = nH
      setMeta(meta)
      setImage(cvs.toDataURL('image/jpeg'))
    }
    fr.readAsDataURL(file)
  }

  const submitModal = (e) =>
  {
    e.preventDefault()
    e.stopPropagation()

    setIsLoading(true)

    let dto = {
      company, uid, cd_license,
      transfer_dtm, payment_type, amount,
      ref_code, pay_month, img, meta,
      remarks,
      is_skipreceipt
    }

    API.acceptPayment(dto).then(resp =>
    {
      if (!resp.success)
        PopMessage.show(resp.msg, '資料存取失敗', 'danger')
      else
      {
        PopMessage.show('已存儲收款記錄', '成功', 'success')
        onClose()
        onUpdated(resp.msg)
      }
      setIsLoading(false)
    })

    return false;
  }

  return (
    <Form onSubmit={submitModal}>
      <div className="split">
        <section>
          <label className="field">
            <strong>公司</strong>
            <select required value={company} onChange={e=> setCompany(e.target.value)}>
              {/* <option value=""> - 請選擇 - </option> */}
              { serviceCompanys.map(comkey =>
                <option key={comkey} value={comkey}>{comkey} - {Util.getCompanyName(comkey)}</option>
              )}
            </select>
          </label>
          <label>
            <strong>指定車牌</strong>
            <div>
              <div className={`tag license ${cd_license===''?'selected':''}`} onClick={e=>setLicense()}>自動選擇</div>
              { owner.vehicles.filter(v => v.services?.length).map(v =>
                <div className={`tag license ${cd_license===v.cd_license?'selected':''}`}
                     onClick={e=>setLicense(v.cd_license)}
                >{ v.cd_license }</div>
              )}
            </div>
          </label>
          <label className="field">
            <strong>入賬種類</strong>
            <select value={payment_type} onChange={e=>setPaymentType(e.target.value.toUpperCase())}>
              <option value="C">C - 現金</option>
              <option value="T">T - 轉賬</option>
              <option value="Q">Q - 支票</option>
              <option value="A">A - 調整</option>
              <Protected allow={['ADMIN']}><option value="Z">Z - 賠償</option></Protected>
              <Protected allow={['ADMIN']}><option value="X">X - 壞賬</option></Protected>
            </select>
          </label>
          <label className="field">
            <strong>入賬日期</strong>
            <DatePicker selected={transfer_dtm} onChange={setTransferDate}
                        dateFormat="yyyy-MM-dd" />
          </label>
          <label className="field">
            <strong>金額</strong>
            <input required type="number" value={amount||0}
              onChange={ e=>setAmount(parseFloat(e.target.value)) } />
          </label>
          <label className="field">
            <strong>參考編號</strong>
            <input type="text" value={ref_code} placeholder="支票尾數/交易編號"
              onChange={ e=>setRefCode(e.target.value) } />
          </label>
          <label className="field">
            <strong>備註</strong>
            <textarea value={remarks}
                    onChange={ e=>setRemarks(e.target.value) }>
            </textarea>
          </label>
          <label className="field">
            <strong>不列印收據</strong>
            <input type="checkbox" checked={is_skipreceipt}
              onChange={ e=> setIsSkipReceipt(e.target.checked) }/>
          </label>

          <div className="error-msg">
            { error }
          </div>
          <div className="action-panel">
            <button className="btn grey" type="button"
                    onClick={onClose}>關閉</button>
            <button className="btn blue" disabled={isLoading}>確定</button>
          </div>
        </section>
        <section>
          <label className="field">
            <strong>檔案</strong>
            <input type="file" onChange={onSetFile}
              accept="image/jpeg,image/png"
            />
          </label>
          <figure className="preview-receipt">
            <svg xmlns="http://www.w3.org/2000/svg"
              viewBox={`0 0 ${meta.img_width} ${meta.img_height}`}
              preserveAspectRatio="xMidYMid meet">
              <image href={img}
                  width={meta.img_width}
                  height={meta.img_height} />
            </svg>
          </figure>
        </section>
      </div>
    </Form>
  );
}

export default PaymentAcceptModal
